import { ProgressBarTop } from "@/components/feedback/ProgressBarLoader"
import Page from "@/components/utilities/Page"
import { useEffect, useState } from "react"
import { useSnapshot } from "valtio"
import { store } from "@/stores/stores"
import { useParams } from "react-router"
import useFetchStatic from "@/hooks/useFetchStatic"
import ScenarioCanvas from "./Scenario.canvas"
import { Background, BackgroundVariant, ReactFlow, ReactFlowProvider } from "@xyflow/react"
import { Scenario } from "@/gen"
import { transformScenarioNodesToFlowNodesAndEdges } from "./components/flow.utils"

interface ScenarioEditProps {}

function ScenarioEdit(props: ScenarioEditProps) {
  useFetchStatic("scenario")
  const snap = useSnapshot(store)
  // const [loading, setLoading] = useState(false)

  useEffect(() => {
    store.scenario.actions.getNodeDefinition()
  }, [])

  const { id } = useParams()
  // let [searchParams] = useSearchParams()
  // const navigate = useNavigate()

  const scenario = snap.scenario.list.find((item) => item.id === id)

  useEffect(() => {
    store.scenario.actions.resetEditing()

    // console.log(id, searchParams)

    // // Create from template if template param is true
    // const isTemplate = searchParams.get("template") === "true"
    // if (isTemplate) {
    //   const template = id === "blank" ? blankTemplate : store.template.list.find((item) => String(item.id) === id)
    //   if (template) {
    //     store.scenario.actions.create(template.initialValues)
    //   } else {
    //     navigate("/scenarios", {
    //       replace: true,
    //     })
    //   }
    // }
  }, [])

  const loading = !scenario || !snap.scenario.nodeDefinitions.list.length

  return (
    <div className="size-screen fixed inset-0 top-0 left-0 z-11">
      <Page title={scenario?.name || "Edit scenario"}>
        <div className={"relative size-full bg-ground"}>
          {loading && <ProgressBarTop size="lg" />}
          {scenario && !loading ? (
            <ScenarioForm scenario={scenario} />
          ) : (
            <ReactFlow fitView>
              <Background id="2" gap={80} color="rgba(0,0,0,0.05)" variant={BackgroundVariant.Lines} />
            </ReactFlow>
          )}
        </div>
      </Page>
    </div>
  )
}

const ScenarioForm = (props: { scenario: Scenario }) => {
  // const form = useForm<typeof scenarioUpdateSchema>({
  //   initialValues: scenarioUpdateSchema.safeParse(props.scenario)?.data as any,
  //   schema: scenarioUpdateSchema,
  // })

  // useEffect(() => {
  //   store.scenario.editing.form = form
  // }, [props.scenario])

  const { nodes, edges } = transformScenarioNodesToFlowNodesAndEdges(props.scenario.nodes)

  return (
    <ReactFlowProvider>
      {/* <Form form={form} className="size-full"> */}
      <ScenarioCanvas scenario={props.scenario} nodes={nodes} edges={edges} />
      {/* </Form> */}
    </ReactFlowProvider>
  )
}

export default ScenarioEdit
